// userMode
export const beforePlay = "beforePlay";
export const duringPlay = "duringPlay";
export const duringAutoPlay = "duringAutoPlay";
//matchState
export const inPlay = "inPlay";
export const wonGame = "wonGame";
export const lostGame = "lostGame";
